import { Injectable } from '@angular/core';
import { HELP_CONTENT } from '../../core/data/help-content.generated';
import {
  HelpArticle,
  HelpAudience,
  HelpAudienceContent,
  HelpCategory,
  HelpContent,
} from '../../core/models/help-content.model';

type AudienceKey = 'kunden' | 'handwerker';

/**
 * Liefert die build-time gebackene FAQ-Datenbank. Keine HTTP-Calls — die
 * Inhalte sind Teil des FE-Bundles (siehe scripts/generate-help-index.mjs
 * und CLAUDE.md → "Decision-Tree-Spec build-time ins FE-Bundle").
 */
@Injectable({ providedIn: 'root' })
export class HelpContentService {
  private readonly content: HelpContent = HELP_CONTENT;

  getAudience(audience: AudienceKey): HelpAudienceContent {
    return this.content[audience];
  }

  getCategories(audience: AudienceKey): HelpCategory[] {
    return [...this.content[audience].categories].sort((a, b) => a.order - b.order);
  }

  getArticlesByCategory(audience: AudienceKey, categoryId: string): HelpArticle[] {
    return this.content[audience].articles.filter((a) => a.category === categoryId);
  }

  getArticle(audience: AudienceKey, slug: string): HelpArticle | undefined {
    return this.content[audience].articles.find((a) => a.slug === slug);
  }

  getRelated(audience: AudienceKey, slugs: string[]): HelpArticle[] {
    if (!slugs?.length) return [];
    return this.content[audience].articles.filter((a) => slugs.includes(a.slug));
  }

  /** Audience name as used in API payloads ('kunde' / 'handwerker'). */
  audienceParam(audience: AudienceKey): HelpAudience {
    return audience === 'kunden' ? 'kunde' : 'handwerker';
  }

  /** Folder/route segment ('kunden' / 'handwerker'). */
  audienceFolder(audience: HelpAudience): AudienceKey {
    return audience === 'kunde' ? 'kunden' : 'handwerker';
  }
}
